<div class="core-loading-container" *ngIf="!hideUntil" role="status" @coreShowHideAnimation>
    <ion-spinner color="primary" aria-hidden="true" />
    <p class="core-loading-message" *ngIf="message" role="status">{{message}}</p>
</div>
<ng-content *ngIf="loaded" @coreShowHideAnimation />
